// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  height: 236.84px;
  width: 442px;
  max-width: 550px;
  min-width: 390px;
  background-color: #191818;
  border: 0;
  border-radius: 10px;
  font-family: "Karla";
}

.card-content {
  padding: 0px;
}

.header h4 {
  font-weight: 500;
  margin-top: 1px;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.41px;
}

.info-row {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}

.info-row>span {
  white-space: nowrap;
}

.info-row>p {
  font-size: 16px;
  margin-top: 1px;
  font-family: "Karla";
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.41px;
}

.image-container {
  position: relative;
  img {
    height: 200px;
    width: 200px;
    border: 0;
    border-radius: 5px;
    cursor: pointer;
  }
}

.revert-button {
  width: 110px !important;
  height: 40.84px !important;
  position: absolute !important;
  top: 176px;
  left: 45px;
  border-radius: 5px !important;
  border: 0.5px solid #50C878 !important;
  color: #50C878 !important;
  background-color: white !important;
  font-family: "Poppins" !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease-in-out !important;
  cursor: pointer !important;

  &:hover {
    background-color: #50C878 !important;
    color: #FFFFFF !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/Setting/Synchronize/components/syncCardStyle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB;IACE,aAAa;IACb,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,UAAU;EACV,UAAU;EACV,6BAA6B;EAC7B,sCAAsC;EACtC,yBAAyB;EACzB,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;EAC3C,0BAA0B;;EAE1B;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;AACF","sourcesContent":[".card {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  height: 236.84px;\n  width: 442px;\n  max-width: 550px;\n  min-width: 390px;\n  background-color: #191818;\n  border: 0;\n  border-radius: 10px;\n  font-family: \"Karla\";\n}\n\n.card-content {\n  padding: 0px;\n}\n\n.header h4 {\n  font-weight: 500;\n  margin-top: 1px;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.41px;\n}\n\n.info-row {\n  display: flex;\n  gap: 6px;\n  align-items: flex-start;\n}\n\n.info-row>span {\n  white-space: nowrap;\n}\n\n.info-row>p {\n  font-size: 16px;\n  margin-top: 1px;\n  font-family: \"Karla\";\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.41px;\n}\n\n.image-container {\n  position: relative;\n  img {\n    height: 200px;\n    width: 200px;\n    border: 0;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n}\n\n.revert-button {\n  width: 110px !important;\n  height: 40.84px !important;\n  position: absolute !important;\n  top: 176px;\n  left: 45px;\n  border-radius: 5px !important;\n  border: 0.5px solid #50C878 !important;\n  color: #50C878 !important;\n  background-color: white !important;\n  font-family: \"Poppins\" !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  transition: all 0.3s ease-in-out !important;\n  cursor: pointer !important;\n\n  &:hover {\n    background-color: #50C878 !important;\n    color: #FFFFFF !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
